import React, {} from 'react';
import {Form, Input, Select, Row, Col, InputNumber} from 'antd';
import {t} from 'utils/i18n';
import {onChangeInput, onBlurInput,} from 'utils/Logics';
import {debound} from 'utils';
import {LABELS} from 'consts';

const OneClassTab = (props) => {
  const onChangeNu = (value) => {
    if(value<0.01){
      props.setNu(0.0001)
    }else {
      props.setNu(Number(value) / 100)
    }
    
  }
  
  return (
    <>
      <Form>
        <Form.Item label={t("Project")} required>
          <Select
            value={props.project}
            onChange={(value) => props.setProject(value)}
            className="fullsize_selectbox"
            showSearch
            placeholder={t("Search project by name...")}
            onSearch={debound(props._onSearchProject, 500)}
            defaultActiveFirstOption={false}
            filterOption={false}
            notFoundContent={null}
            onPopupScroll={props.handleScroll}
            loading={props.loading}
          >
            {
              props.projects.map(p => (
                <Select.Option value={p.project_id} key={p.project_id}>{`${p.name}`}</Select.Option>
              ))
            }
          </Select>
        </Form.Item>
        <Form.Item label={t("Model Name")} required help={props.message.name}>
          <Input
            value={props.models.name}
            onChange={onChangeInput(props._setFieldModels("name"), props._setMessage("name"))}
            onBlur={onBlurInput(props.models.name, props._setMessage("name"), "Model name")}
            maxLength={100}
          />
        </Form.Item>
      </Form>
      <strong>{t("Training data")}</strong>
      <Row gutter={[8, 0]}>
        <Col span={6}>
          <Form>
            <Form.Item label={t("Label")}>
              <Select
                value={props.label}
                onChange={(value) => props.setLabel(value)}
                className="fullsize_selectbox"
              >
                {
                  Object.values(LABELS).map(label => (
                    <Select.Option value={label} key={label}>{`${t(label)}`}</Select.Option>
                  ))
                }
              </Select>
            </Form.Item>
          </Form>
        </Col>
        <Col span={18}>
          <Form>
            <Form.Item label={t("Data name")} required help={props.message.data_ids}>
              <Select
                // mode="multiple"
                placeholder={t("Search data by name...")}
                showSearch
                value={props.models.data_ids && props.models.data_ids[0]}
                onSearch={debound(props._onSearch, 500)}
                defaultActiveFirstOption={false}
                filterOption={false}
                notFoundContent={null}
                onChange={props._onChangeDataName}
              >
                {
                  props.datas.map(d => (
                    <Select.Option value={d.data_id} key={d.data_id}>{`${d.name}`}</Select.Option>
                  ))
                }
              </Select>
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <Row>
        <Form>
          <Form.Item label={t("The ratio of assumption abnormal data (%)")} required help={props.message.data_ids}>
            <InputNumber step={1} min={0.01} max={100} defaultValue={20}
                         onChange={onChangeNu}/>
          </Form.Item>
        </Form>
      </Row>
    </>
  )
}

export default OneClassTab